// extracted by mini-css-extract-plugin
export default {"linkButton":"link-button-linkButton-GZyJ13"};